var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMarkerKotelOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 56,
  viewBox: "0 0 34 56"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "outline",
  fillRule: "nonzero",
  stroke: "#F8E71C",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M22.73 31.943 17.055 46.6 11.4 31.993A16.01 16.01 0 0 1 1 17C1 8.163 8.163 1 17 1s16 7.163 16 16c0 6.66-4.12 12.588-10.27 14.943z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  stroke: "#000",
  d: "M12.55 30.804A14.51 14.51 0 0 1 2.5 17C2.5 8.992 8.992 2.5 17 2.5S31.5 8.992 31.5 17a14.51 14.51 0 0 1-9.922 13.762l-4.522 11.682-4.507-11.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CDCBC9",
  d: "M10 20.473h1.605V13.49H10zm12.606 0h1.605V13.49h-1.605zm-8.384 3.406h5.776v-1.58h-5.776zm0-12.298h5.776v-1.58h-5.776z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22.605 10v2.52l-2.556-2.517h-.01L20.037 10h-2.082v.003l2.053 2.023-3.9 6.606h2.001l3.17-5.354 2.931 2.887V10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.108 15.248h-.007l-3.168 5.354L10 17.714v6.166h1.605v-2.522l2.557 2.519h.01l.002.003h2.083l-.003-.003h.003l-2.054-2.023 3.9-6.606z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M18.102 15.248h-1.995l3.9 6.606-2.053 2.023h.002l-.002.003h2.082l.003-.003h.01l2.556-2.519v2.522h1.605v-6.166l-2.932 2.888-3.169-5.354z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m14.174 10-.003.003h-.01l-2.556 2.518V10H10v6.165l2.933-2.887 3.168 5.354h2.003l-3.9-6.606 2.053-2.023h-.002l.002-.003z"
}))));
export default SvgMarkerKotelOn;